import createStyles from "@material-ui/core/styles/createStyles";
import { Theme } from "@material-ui/core/styles/createMuiTheme";

export const styles = (theme: Theme) =>
  createStyles({
    root: {
      width: "100%"
    },
    card: {
      minWidth: 275,
      textAlign: "center"
    },
    bullet: {
      display: "inline-block",
      margin: "0 2px",
      transform: "scale(0.8)"
    },
    title: {
      fontSize: 14
    },
    points: {
      fontSize: 15
    },
    pos: {
      marginBottom: 12
    }
  });
